import type { Visit } from '.';

export const visitGetters = (state: Visit.State) => ({
  /**
   * Check if the player is currently visiting a friend's pet
   * @return true if the player is visiting, false otherwise
   */
  isVisiting: () => !!state.visit.visitSession,
});
